import React from 'react';

type PlusIconProps = {
  className?: string;
    onClick?: () => void;
    size?: number;
    color?: string;
};

const PlusIcon = ({size=14,color='#1E1E1E', className, onClick }: PlusIconProps) => (
<svg width={size} height={size} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} onClick={onClick}>
<path d="M1 7H13" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M7 13V1" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

);

export default PlusIcon;